import { DateTime } from 'luxon';

import { Sprint } from '@/tracker/types';

const SPRINT_DAYS = 14;

/** Новый спринт — двухнедельный, сразу после последнего открытого, но не в прошлом */
export const nextSprintDates = (sprints: Sprint[]) => {
  const lastEnd = sprints
    .map((sprint) => sprint.endDate)
    .sort()
    .pop();
  const today = DateTime.now().startOf('day');
  const afterLast = lastEnd ? DateTime.fromISO(lastEnd).plus({ days: 1 }) : today;
  const start = DateTime.max(afterLast, today);

  return {
    startDate: start.toISODate()!,
    endDate: start.plus({ days: SPRINT_DAYS - 1 }).toISODate()!,
  };
};
